import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4B88FF",
      "fill-rule": "nonzero",
      d: "m4.449.143.026.026a.5.5 0 0 1 0 .7L1.702 3.7h4.06-.001 4.176C12.181 3.7 14 5.558 14 7.85S12.181 12 9.937 12H5.685l.001-.001-.108.001a.5.5 0 0 1-.5-.5v-.037a.5.5 0 0 1 .5-.5h4.359c1.683 0 3.047-1.394 3.047-3.113S11.62 4.738 9.937 4.738H6.075l-4.367-.001 2.767 2.826a.5.5 0 0 1 0 .7l-.019.018a.5.5 0 0 1-.714 0L.132 4.594a.5.5 0 0 1-.142-.379.5.5 0 0 1 .142-.378L3.742.15a.5.5 0 0 1 .707-.007"
    }, null, -1)
  ])))
}
export default { render: render }